import React from 'react';
import { useSelector } from 'react-redux';
import { Alert } from '@chakra-ui/react';

import { ApplicationState } from '../../../store';
import { UserRole } from '../../../store/auth/types';

const LockedSectionWarning: React.FC = () => {
  const isAgent = useSelector(
    ({ auth }: ApplicationState) => auth.role === UserRole.Agent || auth.role === UserRole.AgencyAdmin,
  );

  return (
    <Alert status="info" colorScheme="cyan" mb={6} data-selector="locked-section-container">
      {isAgent ? (
        <>Note: The university is processing this information and this section cannot be edited at this time. </>
      ) : (
        <>
          Note: The student can no longer access or edit the information in this section due to their current stage in
          CAS Shield.
        </>
      )}
    </Alert>
  );
};

export default LockedSectionWarning;
